/***
 *
 *   ACCOUNT NAV
 *   Acount sub nav that renders different options based
 *   on user permissions. Shows billing & user admin to only account owners
 *
 **********/

import { useContext } from 'react';
import { AuthContext, SubNav } from 'components/lib';

export function AccountNav() {
  const authContext = useContext(AuthContext);
  const hasRestrictedAccountAccess =
    authContext.user?.plan === false ||
    (!!authContext.user?.subscription &&
      authContext.user.subscription !== 'active' &&
      authContext.user.permission !== 'master');

  const items = [
    { link: '/account/profile', label: 'Profile' },
    { link: '/account/password', label: 'Password' },
    ...(authContext.permission?.owner ? [{ link: '/account/organization', label: 'Organization' }] : []),
    ...(hasRestrictedAccountAccess
      ? authContext.permission?.owner
        ? [{ link: '/account/subscription', label: 'Subscription', permission: 'admin' }]
        : []
      : [
          { link: '/account/users', label: 'Users', permission: 'admin' },
          { link: '/account/project-access', label: 'Project Access', permission: 'admin' },
          { link: '/account/subscription', label: 'Subscription', permission: 'admin' },
        ]),
  ];

  return <SubNav items={items} />;
}
